module.exports = __webpack_public_path__ + "static/media/locup.7bee15b8.png";